module.exports = __webpack_public_path__ + "img/lgo.c547aaf7.png";